(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('image-carousel')) return;

    class ImageCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-igc-viewport]');
        this.track = this.querySelector('[data-igc-track]');
        if (!this.viewport || !this.track) return;

        this.originals = Array.from(this.track.children);
        this.count = this.originals.length;
        if (!this.count) return;

        this.prevBtns = Array.from(this.querySelectorAll('[data-igc-prev]'));
        this.nextBtns = Array.from(this.querySelectorAll('[data-igc-next]'));
        this.dotsWrap = this.querySelector('[data-igc-dots]');
        this.progress = this.querySelector('[data-igc-progress]');

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.loopEnabled = this.dataset.loop === 'true' && this.count > 1;
        this.speed = this.reduceMotion ? 0 : parseInt(this.dataset.speed || '550', 10);
        this.clonesEach = -1;
        this.pos = 0;

        this.setup(true);
        this.bindDrag();
        this.bindWheel();
        this.bindKeys();
        this.bindButtons();
        this.bindEditor();
        this.bindAutoplay();

        this.ro = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.setup(false));
        });
        this.ro.observe(this.viewport);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        this.stopAutoplay();
        clearTimeout(this.settleTimer);
        if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
        if (this.blockDeselect) document.removeEventListener('shopify:block:deselect', this.blockDeselect);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      /* ---------- Layout ---------- */

      config() {
        const w = window.innerWidth;
        const bp = w < 750 ? 'mobile' : w < 990 ? 'tablet' : 'desktop';
        return {
          per: parseFloat(this.dataset[bp + 'Per']) || 1,
          peek: parseFloat(this.dataset[bp + 'Peek']) || 0
        };
      }

      setup(first) {
        const keepIndex = first ? 0 : this.activeIndex();
        this.cfg = this.config();
        this.natural = this.dataset.natural === 'true';

        let k = 0;
        if (this.loopEnabled) {
          if (this.natural) {
            const vw = this.viewport.clientWidth;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const widths = this.originals.map((o) => o.getBoundingClientRect().width || 1);
            const minW = Math.max(1, Math.min.apply(null, widths));
            k = Math.min(Math.ceil((vw + gap) / (minW + gap)) + 1, this.count * 4);
          } else {
            k = Math.ceil(this.cfg.per + this.cfg.peek * 2) + 1;
          }
        }
        if (k !== this.clonesEach) this.buildClones(k);

        this.measure();
        this.pos = this.loopEnabled ? this.clonesEach + keepIndex : Math.min(keepIndex, this.maxPos);
        this.apply(false);
        this.buildDots();
        this.updateUI();
      }

      buildClones(k) {
        this.track.querySelectorAll('[data-igc-clone]').forEach((n) => n.remove());
        this.clonesEach = k;
        if (k > 0) {
          const makeClone = (node) => {
            const c = node.cloneNode(true);
            c.setAttribute('data-igc-clone', '');
            c.setAttribute('aria-hidden', 'true');
            c.removeAttribute('data-shopify-editor-block');
            c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            c.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
            c.querySelectorAll('img[loading="lazy"]').forEach((img) => img.setAttribute('loading', 'eager'));
            return c;
          };
          const before = document.createDocumentFragment();
          for (let i = k; i > 0; i--) {
            const idx = (((this.count - i) % this.count) + this.count) % this.count;
            before.appendChild(makeClone(this.originals[idx]));
          }
          this.track.insertBefore(before, this.originals[0]);
          const after = document.createDocumentFragment();
          for (let i = 0; i < k; i++) after.appendChild(makeClone(this.originals[i % this.count]));
          this.track.appendChild(after);
        }
      }

      measure() {
        const items = Array.from(this.track.children);
        const base = items[0].offsetLeft;
        this.lefts = items.map((el) => el.offsetLeft - base);
        this.widths = items.map((el) => el.getBoundingClientRect().width);
        this.gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.viewW = this.viewport.clientWidth;

        const k = this.clonesEach;
        const n = this.count;
        const firstW = this.widths[k] || 1;
        const bothSides = this.dataset.peekMode === 'both' && this.cfg.peek > 0;
        this.offset = bothSides ? this.cfg.peek * firstW + this.gap : 0;

        if (this.loopEnabled) {
          this.period = this.lefts[k + n] - this.lefts[k];
          this.maxShift = Infinity;
          this.maxPos = Infinity;
        } else {
          const last = items.length - 1;
          const trackW = this.lefts[last] + this.widths[last];
          this.maxShift = Math.max(0, trackW - this.viewW);
          let mp = last;
          for (let i = 0; i <= last; i++) {
            if (this.lefts[i] >= this.maxShift - 1) {
              mp = i;
              break;
            }
          }
          this.maxPos = mp;
        }
      }

      xFor(pos) {
        let x = -this.lefts[pos] + this.offset;
        if (!this.loopEnabled) x = Math.min(0, Math.max(-this.maxShift, x));
        return x;
      }

      nearestPos(x) {
        let best = 0;
        let bestD = Infinity;
        for (let i = 0; i < this.lefts.length; i++) {
          const d = Math.abs(-this.lefts[i] + this.offset - x);
          if (d < bestD) {
            bestD = d;
            best = i;
          }
        }
        if (!this.loopEnabled) best = Math.min(best, this.maxPos);
        return best;
      }

      setX(x, animate) {
        this.track.style.transition =
          animate && this.speed ? 'transform ' + this.speed + 'ms cubic-bezier(0.22, 0.61, 0.36, 1)' : 'none';
        this.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      }

      apply(animate) {
        this.setX(this.xFor(this.pos), animate);
      }

      currentTranslate() {
        const t = getComputedStyle(this.track).transform;
        if (!t || t === 'none') return 0;
        return new DOMMatrixReadOnly(t).m41;
      }

      goTo(pos, animate, force) {
        if (animate === undefined) animate = true;
        if (!this.loopEnabled) {
          pos = Math.max(0, Math.min(this.maxPos, pos));
        } else {
          if (!force) {
            const reach = Math.max(1, this.clonesEach - 1);
            pos = Math.max(this.pos - reach, Math.min(this.pos + reach, pos));
          }
          pos = Math.max(0, Math.min(this.lefts.length - 1, pos));
        }
        this.pos = pos;
        this.apply(animate);
        this.updateUI();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalize(), animate ? this.speed + 40 : 0);
      }

      normalize() {
        if (!this.loopEnabled) return;
        const k = this.clonesEach;
        const n = this.count;
        let moved = false;
        while (this.pos < k) { this.pos += n; moved = true; }
        while (this.pos >= k + n) { this.pos -= n; moved = true; }
        if (moved) this.apply(false);
      }

      next() { this.goTo(this.pos + 1); }
      prev() { this.goTo(this.pos - 1); }

      activeIndex() {
        if (!this.loopEnabled) return Math.max(0, Math.min(this.pos, this.count - 1));
        return (((this.pos - this.clonesEach) % this.count) + this.count) % this.count;
      }

      /* ---------- Indicators and buttons ---------- */

      buildDots() {
        if (!this.dotsWrap) return;
        const total = this.loopEnabled ? this.count : this.maxPos + 1;
        if (this.dotsWrap.children.length === total) return;
        this.dotsWrap.innerHTML = '';
        this.dotsWrap.hidden = total < 2;
        for (let i = 0; i < total; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'igc-dot';
          dot.setAttribute('data-igc-control', '');
          dot.setAttribute('aria-label', 'Go to image ' + (i + 1));
          dot.addEventListener('click', () => {
            this.stopAutoplay();
            this.goTo(this.loopEnabled ? this.clonesEach + i : i, true, true);
            this.resumeAutoplay();
          });
          this.dotsWrap.appendChild(dot);
        }
      }

      updateUI() {
        if (!this.loopEnabled) {
          const atStart = this.pos <= 0;
          const atEnd = this.pos >= this.maxPos;
          this.prevBtns.forEach((b) => (b.disabled = atStart));
          this.nextBtns.forEach((b) => (b.disabled = atEnd));
        }
        const active = this.loopEnabled ? this.activeIndex() : this.pos;
        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((d, i) => {
            d.setAttribute('aria-current', i === active ? 'true' : 'false');
          });
        }
        if (this.progress) {
          const total = this.loopEnabled ? this.count : this.maxPos + 1;
          const w = 100 / Math.max(1, total);
          this.progress.style.setProperty('--igc-progress-w', w + '%');
          this.progress.style.setProperty('--igc-progress-x', active * 100 + '%');
        }
      }

      bindButtons() {
        this.prevBtns.forEach((b) =>
          b.addEventListener('click', () => {
            this.stopAutoplay();
            this.prev();
            this.resumeAutoplay();
          })
        );
        this.nextBtns.forEach((b) =>
          b.addEventListener('click', () => {
            this.stopAutoplay();
            this.next();
            this.resumeAutoplay();
          })
        );
      }

      /* ---------- Drag, swipe, pan ---------- */

      bindDrag() {
        const vp = this.viewport;

        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('[data-igc-control]')) return;
          this.drag = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY,
            startX: this.currentTranslate(),
            lastX: e.clientX,
            lastT: performance.now(),
            v: 0,
            decided: false,
            active: false
          };
        });

        vp.addEventListener('pointermove', (e) => {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          const dx = e.clientX - d.x;
          const dy = e.clientY - d.y;

          if (!d.decided) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            d.decided = true;
            if (Math.abs(dx) <= Math.abs(dy)) {
              this.drag = null;
              return;
            }
            d.active = true;
            this.stopAutoplay();
            clearTimeout(this.settleTimer);
            try { vp.setPointerCapture(e.pointerId); } catch (err) {}
            this.classList.add('is-dragging');
            if (this.loopEnabled) {
              const k = this.clonesEach;
              const n = this.count;
              const p = this.nearestPos(d.startX);
              if (p < k) d.startX -= this.period;
              else if (p >= k + n) d.startX += this.period;
            }
            this.setX(d.startX, false);
          }

          if (!d.active) return;
          e.preventDefault();

          let x = d.startX + dx;
          if (!this.loopEnabled) {
            if (x > 0) x = x * 0.35;
            const min = -this.maxShift;
            if (x < min) x = min + (x - min) * 0.35;
          }
          this.setX(x, false);

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.v = 0.8 * ((e.clientX - d.lastX) / dt) + 0.2 * d.v;
            d.lastX = e.clientX;
            d.lastT = now;
          }
        });

        const end = (e) => {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          this.drag = null;
          if (!d.active) return;
          this.classList.remove('is-dragging');
          try { vp.releasePointerCapture(e.pointerId); } catch (err) {}

          const dx = e.clientX - d.x;
          const startPos = this.nearestPos(d.startX);
          const fling = performance.now() - d.lastT < 120 ? d.v * 160 : 0;
          let target = this.nearestPos(d.startX + dx + fling);
          if (target === startPos && Math.abs(dx) > 30) target = startPos + (dx < 0 ? 1 : -1);

          this.pos = startPos;
          this.goTo(target);

          this.suppressClick = true;
          setTimeout(() => (this.suppressClick = false), 80);
          this.resumeAutoplay();
        };

        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);
        vp.addEventListener(
          'click',
          (e) => {
            if (this.suppressClick) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
        vp.addEventListener('dragstart', (e) => e.preventDefault());
      }

      bindWheel() {
        let acc = 0;
        let locked = false;
        this.viewport.addEventListener(
          'wheel',
          (e) => {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault();
            if (locked) return;
            acc += e.deltaX;
            if (Math.abs(acc) > 40) {
              this.stopAutoplay();
              if (acc > 0) this.next();
              else this.prev();
              acc = 0;
              locked = true;
              setTimeout(() => {
                locked = false;
                this.resumeAutoplay();
              }, Math.max(350, this.speed));
            }
          },
          { passive: false }
        );
      }

      bindKeys() {
        this.viewport.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
          else if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); }
        });
      }

      /* ---------- Auto slide ---------- */

      bindAutoplay() {
        this.autoplayOn = this.dataset.autoplay === 'true' && !this.reduceMotion && this.count > 1;
        if (!this.autoplayOn) return;
        this.hovering = false;
        this.addEventListener('mouseenter', () => { this.hovering = true; this.stopAutoplay(); });
        this.addEventListener('mouseleave', () => { this.hovering = false; this.resumeAutoplay(); });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.resumeAutoplay());
        this.onVisibility = () => (document.hidden ? this.stopAutoplay() : this.resumeAutoplay());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.resumeAutoplay();
      }

      stopAutoplay() {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }

      resumeAutoplay() {
        if (!this.autoplayOn || this.hovering || this.autoTimer || this.editorPaused) return;
        const ms = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
        this.autoTimer = setInterval(() => {
          if (!this.loopEnabled && this.pos >= this.maxPos) this.goTo(0);
          else this.next();
        }, ms);
      }

      /* ---------- Theme editor ---------- */

      bindEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        this.blockSelect = (e) => {
          if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.originals.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i < 0) return;
          this.editorPaused = true;
          this.stopAutoplay();
          this.goTo(this.loopEnabled ? this.clonesEach + i : i, true, true);
        };
        this.blockDeselect = (e) => {
          if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
          this.editorPaused = false;
          this.resumeAutoplay();
        };
        document.addEventListener('shopify:block:select', this.blockSelect);
        document.addEventListener('shopify:block:deselect', this.blockDeselect);
      }
    }

    customElements.define('image-carousel', ImageCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('video-carousel')) return;

    class VideoCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-vc-viewport]');
        this.track = this.querySelector('[data-vc-track]');
        if (!this.viewport || !this.track) return;

        this.originals = Array.from(this.track.children);
        this.count = this.originals.length;
        if (!this.count) return;

        this.prevBtns = Array.from(this.querySelectorAll('[data-vc-prev]'));
        this.nextBtns = Array.from(this.querySelectorAll('[data-vc-next]'));
        this.dotsWrap = this.querySelector('[data-vc-dots]');

        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        this.loopEnabled = this.dataset.loop === 'true' && this.count > 1;
        this.mode = this.dataset.playMode || 'autoplay';
        this.speed = this.reduceMotion ? 0 : parseInt(this.dataset.speed || '550', 10);
        this.clonesEach = -1;
        this.pos = 0;
        this.currentX = 0;

        this.setup(true);
        this.bindDrag();
        this.bindWheel();
        this.bindKeys();
        this.bindButtons();
        this.bindVideoEvents();
        this.bindEditor();
        this.bindAutoplay();

        this.resizeFrame = null;
        this.ro = new ResizeObserver(() => {
          cancelAnimationFrame(this.resizeFrame);
          this.resizeFrame = requestAnimationFrame(() => this.setup(false));
        });
        this.ro.observe(this.viewport);
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        this.stopAutoplay();
        clearTimeout(this.settleTimer);
        if (this.blockSelect) document.removeEventListener('shopify:block:select', this.blockSelect);
        if (this.blockDeselect) document.removeEventListener('shopify:block:deselect', this.blockDeselect);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      /* ---------- Layout ---------- */

      breakpoint() {
        const w = window.innerWidth;
        if (w < 750) return 'mobile';
        if (w < 990) return 'tablet';
        return 'desktop';
      }

      config() {
        const bp = this.breakpoint();
        return {
          bp: bp,
          per: parseFloat(this.dataset[bp + 'Per']) || 1,
          peek: parseFloat(this.dataset[bp + 'Peek']) || 0
        };
      }

      setup(first) {
        const keepIndex = first ? 0 : this.activeIndex();
        this.cfg = this.config();

        let k = 0;
        if (this.loopEnabled) k = Math.ceil(this.cfg.per + this.cfg.peek * 2) + 1;
        if (k !== this.clonesEach) this.buildClones(k);

        this.measure();
        this.pos = this.loopEnabled ? this.clonesEach + keepIndex : Math.min(keepIndex, this.maxPos);
        this.apply(false);
        this.buildDots();
        this.updateUI();
      }

      buildClones(k) {
        this.track.querySelectorAll('[data-vc-clone]').forEach((n) => n.remove());
        this.clonesEach = k;

        if (k > 0) {
          const makeClone = (node) => {
            const c = node.cloneNode(true);
            c.setAttribute('data-vc-clone', '');
            c.setAttribute('aria-hidden', 'true');
            c.querySelectorAll('button, a, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
            c.removeAttribute('data-shopify-editor-block');
            c.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
            c.classList.remove('is-playing', 'is-unmuted');
            return c;
          };

          const before = document.createDocumentFragment();
          for (let i = k; i > 0; i--) {
            const idx = (((this.count - i) % this.count) + this.count) % this.count;
            before.appendChild(makeClone(this.originals[idx]));
          }
          this.track.insertBefore(before, this.originals[0]);

          const after = document.createDocumentFragment();
          for (let i = 0; i < k; i++) {
            after.appendChild(makeClone(this.originals[i % this.count]));
          }
          this.track.appendChild(after);
        }

        this.refreshVideos();
      }

      measure() {
        const first = this.originals[0];
        this.slideW = first.getBoundingClientRect().width;
        this.gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.step = this.slideW + this.gap;
        this.viewW = this.viewport.clientWidth;

        const bothSides = this.dataset.peekMode === 'both' && this.cfg.peek > 0;
        this.offset = bothSides ? this.cfg.peek * this.slideW + this.gap : 0;

        const trackW = this.count * this.slideW + (this.count - 1) * this.gap;
        this.maxShift = Math.max(0, trackW - this.viewW);
        this.maxPos = this.loopEnabled
          ? Infinity
          : Math.max(0, Math.ceil((this.maxShift - 1) / this.step));
      }

      xFor(pos) {
        let x = -pos * this.step + this.offset;
        if (!this.loopEnabled) x = Math.min(0, Math.max(-this.maxShift, x));
        return x;
      }

      setX(x, animate) {
        this.track.style.transition =
          animate && this.speed ? 'transform ' + this.speed + 'ms cubic-bezier(0.22, 0.61, 0.36, 1)' : 'none';
        this.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
        this.currentX = x;
      }

      apply(animate) {
        this.setX(this.xFor(this.pos), animate);
      }

      currentTranslate() {
        const t = getComputedStyle(this.track).transform;
        if (!t || t === 'none') return 0;
        return new DOMMatrixReadOnly(t).m41;
      }

      goTo(pos, animate, force) {
        if (animate === undefined) animate = true;
        if (!this.loopEnabled) {
          pos = Math.max(0, Math.min(this.maxPos, pos));
        } else if (!force) {
          const reach = Math.max(1, this.clonesEach - 1);
          pos = Math.max(this.pos - reach, Math.min(this.pos + reach, pos));
        }
        this.pos = pos;
        this.apply(animate);
        this.updateUI();

        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.normalize(), animate ? this.speed + 40 : 0);
      }

      normalize() {
        if (!this.loopEnabled) return;
        const k = this.clonesEach;
        const n = this.count;
        let moved = false;
        while (this.pos < k) {
          this.pos += n;
          moved = true;
        }
        while (this.pos >= k + n) {
          this.pos -= n;
          moved = true;
        }
        if (moved) this.apply(false);
      }

      next() {
        this.goTo(this.pos + 1);
      }

      prev() {
        this.goTo(this.pos - 1);
      }

      activeIndex() {
        if (!this.loopEnabled) return Math.max(0, Math.min(this.pos, this.count - 1));
        return (((this.pos - this.clonesEach) % this.count) + this.count) % this.count;
      }

      /* ---------- Dots and buttons ---------- */

      buildDots() {
        if (!this.dotsWrap) return;
        const total = this.loopEnabled ? this.count : this.maxPos + 1;
        if (this.dotsWrap.children.length === total) return;
        this.dotsWrap.innerHTML = '';
        this.dotsWrap.hidden = total < 2;
        for (let i = 0; i < total; i++) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'vc-dot';
          dot.setAttribute('data-vc-control', '');
          dot.setAttribute('aria-label', 'Go to video ' + (i + 1));
          dot.addEventListener('click', () => {
            this.stopAutoplay();
            this.goTo(this.loopEnabled ? this.clonesEach + i : i, true, true);
            this.resumeAutoplay();
          });
          this.dotsWrap.appendChild(dot);
        }
      }

      updateUI() {
        if (!this.loopEnabled) {
          const atStart = this.pos <= 0;
          const atEnd = this.pos >= this.maxPos;
          this.prevBtns.forEach((b) => (b.disabled = atStart));
          this.nextBtns.forEach((b) => (b.disabled = atEnd));
        }
        if (this.dotsWrap) {
          const active = this.loopEnabled ? this.activeIndex() : this.pos;
          Array.from(this.dotsWrap.children).forEach((d, i) => {
            d.setAttribute('aria-current', i === active ? 'true' : 'false');
          });
        }
      }

      bindButtons() {
        this.prevBtns.forEach((b) =>
          b.addEventListener('click', () => {
            this.stopAutoplay();
            this.prev();
            this.resumeAutoplay();
          })
        );
        this.nextBtns.forEach((b) =>
          b.addEventListener('click', () => {
            this.stopAutoplay();
            this.next();
            this.resumeAutoplay();
          })
        );
      }

      /* ---------- Drag, swipe, pan ---------- */

      bindDrag() {
        const vp = this.viewport;

        vp.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          if (e.target.closest('[data-vc-control]')) return;
          this.drag = {
            id: e.pointerId,
            x: e.clientX,
            y: e.clientY,
            startX: this.currentTranslate(),
            lastX: e.clientX,
            lastT: performance.now(),
            v: 0,
            decided: false,
            active: false
          };
        });

        vp.addEventListener('pointermove', (e) => {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          const dx = e.clientX - d.x;
          const dy = e.clientY - d.y;

          if (!d.decided) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            d.decided = true;
            if (Math.abs(dx) <= Math.abs(dy)) {
              this.drag = null;
              return;
            }
            d.active = true;
            this.stopAutoplay();
            clearTimeout(this.settleTimer);
            try {
              vp.setPointerCapture(e.pointerId);
            } catch (err) {}
            this.classList.add('is-dragging');

            if (this.loopEnabled) {
              const k = this.clonesEach;
              const n = this.count;
              const p = Math.round((this.offset - d.startX) / this.step);
              if (p < k) d.startX -= n * this.step;
              else if (p >= k + n) d.startX += n * this.step;
            }
            this.setX(d.startX, false);
          }

          if (!d.active) return;
          e.preventDefault();

          let x = d.startX + dx;
          if (!this.loopEnabled) {
            if (x > 0) x = x * 0.35;
            const min = -this.maxShift;
            if (x < min) x = min + (x - min) * 0.35;
          }
          this.setX(x, false);

          const now = performance.now();
          const dt = now - d.lastT;
          if (dt > 0) {
            d.v = 0.8 * ((e.clientX - d.lastX) / dt) + 0.2 * d.v;
            d.lastX = e.clientX;
            d.lastT = now;
          }
        });

        const end = (e) => {
          const d = this.drag;
          if (!d || e.pointerId !== d.id) return;
          this.drag = null;
          if (!d.active) return;

          this.classList.remove('is-dragging');
          try {
            vp.releasePointerCapture(e.pointerId);
          } catch (err) {}

          const dx = e.clientX - d.x;
          const startPos = Math.round((this.offset - d.startX) / this.step);
          const fling = performance.now() - d.lastT < 120 ? -d.v * 160 : 0;
          let target = Math.round(startPos + (-dx + fling) / this.step);
          if (target === startPos && Math.abs(dx) > 30) target = startPos + (dx < 0 ? 1 : -1);

          this.pos = startPos;
          this.goTo(target);

          this.suppressClick = true;
          setTimeout(() => (this.suppressClick = false), 80);
          this.resumeAutoplay();
        };

        vp.addEventListener('pointerup', end);
        vp.addEventListener('pointercancel', end);

        vp.addEventListener(
          'click',
          (e) => {
            if (this.suppressClick) {
              e.preventDefault();
              e.stopPropagation();
            }
          },
          true
        );
        vp.addEventListener('dragstart', (e) => e.preventDefault());
      }

      bindWheel() {
        let acc = 0;
        let locked = false;
        this.viewport.addEventListener(
          'wheel',
          (e) => {
            if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
            e.preventDefault();
            if (locked) return;
            acc += e.deltaX;
            if (Math.abs(acc) > 40) {
              this.stopAutoplay();
              if (acc > 0) this.next();
              else this.prev();
              acc = 0;
              locked = true;
              setTimeout(() => {
                locked = false;
                this.resumeAutoplay();
              }, Math.max(350, this.speed));
            }
          },
          { passive: false }
        );
      }

      bindKeys() {
        this.viewport.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') {
            e.preventDefault();
            this.next();
          } else if (e.key === 'ArrowLeft') {
            e.preventDefault();
            this.prev();
          }
        });
      }

      /* ---------- Autoplay slides ---------- */

      bindAutoplay() {
        this.autoplayOn = this.dataset.autoplay === 'true' && !this.reduceMotion && this.count > 1;
        if (!this.autoplayOn) return;
        this.hovering = false;
        this.addEventListener('mouseenter', () => {
          this.hovering = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.hovering = false;
          this.resumeAutoplay();
        });
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.resumeAutoplay());
        this.onVisibility = () => (document.hidden ? this.stopAutoplay() : this.resumeAutoplay());
        document.addEventListener('visibilitychange', this.onVisibility);
        this.resumeAutoplay();
      }

      stopAutoplay() {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }

      resumeAutoplay() {
        if (!this.autoplayOn || this.hovering || this.autoTimer || this.editorPaused) return;
        const ms = (parseFloat(this.dataset.autoplaySpeed) || 5) * 1000;
        this.autoTimer = setInterval(() => {
          if (!this.loopEnabled && this.pos >= this.maxPos) this.goTo(0);
          else this.next();
        }, ms);
      }

      /* ---------- Videos ---------- */

      refreshVideos() {
        this.videos = Array.from(this.track.querySelectorAll('video'));
        this.videos.forEach((v) => {
          v.muted = true;
          v.loop = true;
          v.playsInline = true;
          v.setAttribute('playsinline', '');
          v.removeAttribute('controls');
          v.removeAttribute('autoplay');
        });

        if (this.io) this.io.disconnect();
        const inViewMode = this.mode === 'autoplay' || (this.mode === 'hover' && !this.canHover);
        if (inViewMode && 'IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((en) => {
                if (en.isIntersecting && en.intersectionRatio >= 0.5) this.playVideo(en.target);
                else en.target.pause();
              });
            },
            { threshold: [0, 0.5, 1] }
          );
          this.videos.forEach((v) => this.io.observe(v));
        }
      }

      playVideo(v) {
        const p = v.play();
        if (p && typeof p.catch === 'function') p.catch(() => {});
      }

      muteOthers(except) {
        this.videos.forEach((v) => {
          if (v === except) return;
          v.muted = true;
          const slide = v.closest('.vc-slide');
          if (slide) {
            slide.classList.remove('is-unmuted');
            const btn = slide.querySelector('[data-vc-mute]');
            if (btn) btn.setAttribute('aria-pressed', 'false');
          }
        });
      }

      bindVideoEvents() {
        this.track.addEventListener(
          'play',
          (e) => {
            const slide = e.target.closest && e.target.closest('.vc-slide');
            if (slide) slide.classList.add('is-playing');
          },
          true
        );
        this.track.addEventListener(
          'pause',
          (e) => {
            const slide = e.target.closest && e.target.closest('.vc-slide');
            if (slide) slide.classList.remove('is-playing');
          },
          true
        );

        if (this.mode === 'hover' && this.canHover) {
          this.track.addEventListener('mouseover', (e) => {
            const slide = e.target.closest('.vc-slide');
            if (!slide || slide.contains(e.relatedTarget)) return;
            const v = slide.querySelector('video');
            if (v) this.playVideo(v);
          });
          this.track.addEventListener('mouseout', (e) => {
            const slide = e.target.closest('.vc-slide');
            if (!slide || slide.contains(e.relatedTarget)) return;
            const v = slide.querySelector('video');
            if (v) v.pause();
          });
        }

        this.track.addEventListener('click', (e) => {
          if (this.suppressClick) return;
          const slide = e.target.closest('.vc-slide');
          if (!slide) return;
          const v = slide.querySelector('video');
          if (!v) return;

          const muteBtn = e.target.closest('[data-vc-mute]');
          if (muteBtn) {
            v.muted = !v.muted;
            slide.classList.toggle('is-unmuted', !v.muted);
            muteBtn.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
            if (!v.muted) {
              this.muteOthers(v);
              this.playVideo(v);
            }
            return;
          }

          if (this.mode === 'click') {
            if (v.paused) {
              this.videos.forEach((o) => {
                if (o !== v) o.pause();
              });
              v.muted = false;
              this.playVideo(v);
            } else {
              v.pause();
            }
          }
        });
      }

      /* ---------- Theme editor ---------- */

      bindEditor() {
        if (!window.Shopify || !window.Shopify.designMode) return;
        this.blockSelect = (e) => {
          if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
          const i = this.originals.findIndex((s) => s.dataset.blockId === e.detail.blockId);
          if (i < 0) return;
          this.editorPaused = true;
          this.stopAutoplay();
          this.goTo(this.loopEnabled ? this.clonesEach + i : i, true, true);
        };
        this.blockDeselect = (e) => {
          if (!e.detail || e.detail.sectionId !== this.dataset.sectionId) return;
          this.editorPaused = false;
          this.resumeAutoplay();
        };
        document.addEventListener('shopify:block:select', this.blockSelect);
        document.addEventListener('shopify:block:deselect', this.blockDeselect);
      }
    }

    customElements.define('video-carousel', VideoCarousel);
  })();

  } catch(e) { console.error(e); }
})();
})();
